import axios from "axios"

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

const token = localStorage.getItem('authToken')
axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}





